import color from '@deprecated-ui/_style/color';
import { useLivePriceSingleReceiver } from 'global/Datafeed/UseLivePrice/useLivePriceSingleReceiver';
import numeral from 'numeral';
import { Td } from './styled';

const ChangePercentage = ({ change, percent, symbol }) => {
  const { livePrice } = useLivePriceSingleReceiver(
    symbol,
    'sector_change_percentage',
  );

  let textColor = color.midgray;
  const livePriceChange = livePrice?.change;
  const livePercentChange = livePrice?.percentage_change;

  const showLivePrice = typeof livePercentChange !== 'undefined';
  let prefix = '';

  const priceChange = showLivePrice ? livePriceChange : parseInt(change, 10);

  if (priceChange > 0) {
    textColor = color.primary;
    prefix = '+';
  }
  if (priceChange < 0) {
    textColor = color.sunsetOrange;
  }

  let showedResult = `${numeral(percent).format('0.00')}%`;

  if (livePriceChange && livePercentChange) {
    showedResult = `${numeral(livePercentChange).format('0.00')}%`;
  }

  return (
    <Td align="right" color={textColor} p="0 0 0 35px">
      {prefix}
      {showedResult}
    </Td>
  );
};

export default ChangePercentage;
